import { render, staticRenderFns } from "./GongGao.vue?vue&type=template&id=df3c46e2&scoped=true"
import script from "./GongGao.vue?vue&type=script&lang=js"
export * from "./GongGao.vue?vue&type=script&lang=js"
import style0 from "./GongGao.vue?vue&type=style&index=0&id=df3c46e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df3c46e2",
  null
  
)

export default component.exports